export enum CurrentLoginPage {
  Credentials,
  OtpVerification,
}
